module.exports = __webpack_public_path__ + "static/media/ic_nav_05.41cbf9bf.svg";